export const calculatePrice = (prices, discounts, keys, months, vatRate) => {
    if (!prices || !discounts) return { total: 0, discountedTotal: 0, discount: 0 };
  
    let discountPercentage = 0;
    Object.keys(discounts).forEach((threshold) => {
      if (months >= parseInt(threshold, 10)) {
        discountPercentage = discounts[threshold];
      }
    });

    let basePrice = 0;
    Object.keys(prices).forEach((threshold) => {
      if (months >= parseInt(threshold, 10)) {
        basePrice = prices[threshold];
      }
    });

    const vatFactor = 1 + vatRate / 100;    
    const total = keys * months * basePrice;
    const totalNoVat = (total / vatFactor).toFixed(2);
    const highestTotal = prices[1] * keys * months;
    const discountedTotal = (highestTotal - total).toFixed(2);
    const discountedTotalNoVat = (total * (1 - discountPercentage / 100) * (1 - vatRate / 100)).toFixed(2);

    return { total, totalNoVat, discountedTotal, discount: discountPercentage, discountedTotalNoVat };
  };

  export const determineExpirationDate = (startDate, months) => {
    const expirationDate = new Date(startDate);
    expirationDate.setMonth(expirationDate.getMonth() + months);
  
    return expirationDate;
  };


// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Order/OrderUtils.js